module.exports = __webpack_public_path__ + "img/shipping.36715461.jpg";